(function () {
  'use strict';

  angular
    .module('filter.price', [])

    /* @ngInject */
    .filter('price', ["$rootScope", "AppService", function ($rootScope, AppService) {
      var params = null;

      function priceFilter(prices, str, ttc) {
        if (prices === null || angular.isUndefined(prices) || (!angular.isObject(prices) && isNaN(prices))) return prices;
        ttc = ttc === 'ht' ? false : true;

        if (params !== null) {
          return !angular.isFunction(params.then) ? getPriceFilter(prices, str, ttc) : undefined;
        }
        params = AppService.getParams()
          .then(function (data) {
            params = data;
          })
          .catch(function (error) {
            console.error(error);
          });
      }

      function getPriceFilter(prices, str, ttc) {
        if (!angular.isFunction(format)) return prices;

        var loc = params.Localization,
          value,
          template = params.Visitor.CardType.ShowTTCPrice ? loc.PriceHTMLFormatVATincluded : loc.PriceHTMLFormatVATexcluded;

        switch (str) {
          case 'value':
          case 'round-value':
            value = prices;
            template = ttc ? loc.PriceHTMLFormatVATincluded : loc.PriceHTMLFormatVATexcluded;
            break;
          case 'amount-price':
            value = params.Visitor.CardType.ShowTTCPrice ? prices.TTCAmount : prices.HTAmount;
            break;
          case 'final-price':
            value = params.Visitor.CardType.ShowTTCPrice ? prices.TTCDiscountedPrice : prices.HTDiscountedPrice;
            break;
          case 'total-price':
            value = params.Visitor.CardType.ShowTTCPrice ? prices.TTCTotalPrice : prices.HTTotalPrice;
            break;
          default:
            value = params.Visitor.CardType.ShowTTCPrice ? prices.TTCPrice : prices.HTPrice;
        }
        if (angular.isUndefined(value)) return;

        var strMontant = format(loc.PriceFormat, parseFloat(value)),
          separatorIndex = strMontant.indexOf('.');

        if (str === 'round-value' && Math.floor(value) === value) {
          template = template.replace('[%decimal-separator%]', '');
          template = template.replace('[%amount-dec%]', '');
        }

        var render = template.replace('[%amount%]', strMontant)
                             .replace(',', '##PriceTSep##')
                             .replace('[%amount-int%]', separatorIndex !== -1 ? strMontant.substring(0, separatorIndex) : strMontant)
                             .replace('[%amount-dec%]', separatorIndex !== -1 ? strMontant.substring(separatorIndex + 1) : '')
                             .replace('[%decimal-separator%]', loc.PriceDecimalSeparator)
                             .replace('.', loc.PriceDecimalSeparator)
                             .replace('##PriceTSep##', loc.PriceThousandSeparator)
                             .replace('[%currency%]', params.Currency.Symbol)
                             .replace('[%currencyCode%]', params.Currency.ISOCode);

        return render;
      }

      $rootScope.$on('logUpdate', function () {
        params = null;
      });

      priceFilter.$stateful = true;
      return priceFilter;
    }]);

})();
